<template>
    <div>
        <div>
            <div class="mypage-title" v-if="posisalo_access_status != 1">
                {{ characters.subscription_type }}
            </div>
            <div class="mypage-item" v-if="posisalo_access_status != 1">
                {{ convTypeToString(type) }}
            </div>
            <div class="mypage-title" v-if="posisalo_access_status != 1">
                {{ characters.subscription_edate }}
            </div>
            <div class="mypage-item" v-if="posisalo_access_status != 1">
                {{ edate }}
            </div>
            <div class="mypage-title" v-if="posisalo_access_status != 1">
                {{ characters.subscription_continue }}
            </div>
            <div v-if="continue_flag==0 && posisalo_access_status != 1" class="mypage-item">
                {{ characters.disabled }}<br />
                <button v-if="pay_kind=='credit'" @click="changeToAbledContinueFlag()">{{ characters.update_to_abled }}</button>
            </div>
            <div v-if="continue_flag==1 && posisalo_access_status != 1" class="mypage-item">
                {{ characters.abled }}<br />
                <button @click="changeToDisabledContinueFlag()">{{ characters.update_to_disabled }}</button>
            </div>
            <div class="mypage-title" v-if="pay_kind=='credit'">
                {{ characters.credit_regist_status }}
            </div>
            <div v-if="credit_reg_flag==0 && pay_kind=='credit'" class="mypage-item">
                {{ characters.unregisted }}<br />
                <button @click="registCreditCard()">{{ characters.regist }}</button>
            </div>
            <div v-if="credit_reg_flag==1 && pay_kind=='credit'" class="mypage-item">
                {{ characters.registed }}<br />
                <button @click="registCreditCard()">{{ characters.edit }}</button>
            </div>
            <div v-if="continue_flag!=0 && continue_flag!=1" class="mypage-item"></div>
            <div class="mypage-title">
                {{ characters.pay_kind }}
            </div>
            <div  class="mypage-item">
                {{ characters[pay_kind] }}<br />
            </div>
        </div>
        <div class="confirm" v-if="type==0">
            <button type="submit" @click="jumpSubscriptionPurchase()">{{ characters.open_subscription_purchase_page }}</button>
        </div>
        <div class="confirm">
            <button type="submit" @click="jumpSubscriptionPurchaseHistory()">{{ characters.open_subscription_history_page }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "subscription-confirm",
        props: ['posisalo_access_status', 'json_characters'],
        data: function () {
            return {
                type_str: String,
                type: Number,
                sdate: '',
                edate: '',
                continueFlag: Number,
                credit_reg_flag: Number,
                characters: Object,
                pay_kind:'',
            }
        },
        mounted() {
            axios.default
                .get('/subscription/status/get')
                .then(response => {
                    const r = response.data;
                    this.type = r.type;
                    this.sdate = r.sdate;
                    this.edate = r.edate;
                    this.continue_flag = r.continue_flag;
                    this.credit_reg_flag = r.credit_reg_flag;
                    this.pay_kind = r.pay_kind;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            convTypeToString(type) {
                if(type == 0) return this.characters.general_member;
                if(type == 1) return this.characters.subscription_member;
                // if(type == 2) return 'プレミアム会員';
            },
            jumpSubscriptionPurchase: function() {
                location.href="/subscription/purchase";
            },
            jumpSubscriptionPurchaseHistory: function() {
                location.href="/subscription/purchase/history";
            },
            changeToAbledContinueFlag() {
                if(this.pay_kind == 'credit') {
                    this.changeContinueFlag('abled');
                    return;
                }
            },
            changeToDisabledContinueFlag() {
                if(confirm(this.characters.continue_disabled_message)) {
                    const credit_pay_kind = ['credit'];
                    const carrer_pay_kind = ['docomo', 'au', 'softbank'];
                    const deffered_pay_kind = ['bank_transfer', 'mail_send'];
                    if(credit_pay_kind.findIndex(pay_kind => pay_kind ===this.pay_kind) != -1) {
                        this.changeContinueFlag('disabled');
                    } else if(carrer_pay_kind.findIndex(pay_kind => pay_kind ===this.pay_kind) != -1) {
                        this.endCareerSubscription();
                    } else if(deffered_pay_kind.findIndex(pay_kind => pay_kind ===this.pay_kind) != -1){
                        this.endDefferedSubscription();
                    }
                }
            },
            changeContinueFlag(status) {
                axios.default
                    .post('/subscription/continue/change', {status: status})
                    .then(response => {
                        const r = response.data;
                        const s = r.status;
                        if(s=='error') {
                            alert(this.characters[r.msg]);
                            if(r.msg=='credit_unregist') {
                                location.href="/credit/regist?status=unregisted";
                            }
                        } else {
                            location.href="/subscription/confirm"
                        }
                    });
            },
            endCareerSubscription() {
                axios.default
                    .post('/subscription/continue/end/career')
                    .then(response => {
                        const r = response.data;
                        if(r.err) {
                            alert(this.characters[r.err]);
                            return;
                        } else {
                            location.href=r.url;
                            return;
                        }
                    });
            },
            endDefferedSubscription() {
                axios.default
                    .post('/subscription/continue/end/deffered')
                    .then(response => {
                        const r = response.data;
                        if(r.err) {
                            alert(this.characters[r.err]);
                            return;
                        } else {
                            location.href=r.url;
                            return;
                        }
                    });
            },
            registCreditCard() {
                location.href="/credit/regist";
            }
        }
    }
</script>

<style scoped>
</style>
